import React from "react";
import { Navigate } from "react-router-dom";
const decipher = salt => {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
      .map(hex => parseInt(hex, 16))
      .map(applySaltToChar)
      .map(charCode => String.fromCharCode(charCode))
      .join('');
  }
  var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
  
const ProtectedRoute = ({ children, allowedRoles }) => {
  // Check if user's role is allowed

  var k= localStorage.getItem("k");
  if(k !== "" && k !== undefined && k !== null)
  {
    var userinfo = decode(k);
    var user = JSON.parse(userinfo);
  // console.log("user", user.role)
    var localStorageDecode = user.role;
  }
  else{
    var localStorageDecode = "";
  }
// console.log("allowedRoles",allowedRoles)
// console.log("localStorageDecode",localStorageDecode)
// console.log("asdsa", !allowedRoles.indexOf(localStorageDecode))
  if (!allowedRoles.includes(localStorageDecode)) {
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
};

export default ProtectedRoute;
